import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=9810be1c&scoped=true&"
import script from "./Skills.vue?vue&type=script&lang=ts&"
export * from "./Skills.vue?vue&type=script&lang=ts&"
import style0 from "./Skills.vue?vue&type=style&index=0&id=9810be1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9810be1c",
  null
  
)

export default component.exports